/** Customer storefront / marketing / cart — all supported languages. */
export const storefrontModuleTranslations = {
  en: {
    header_follow: 'Follow us:',
    nav_site_label: 'Site',
    nav_about: 'About Us',
    nav_products: 'Products',
    nav_features: 'Features',
    nav_contact: 'Contact',
    nav_account_label: 'My account',
    nav_my_profile: 'My profile',
    nav_my_orders: 'My orders',
    nav_referrals: 'Referrals',
    referral_fab_title: 'Referrals',
    referral_fab_aria: 'Open referrals — invite friends and earn rewards',
    scroll_prompt_title: "Can't find what you're looking for?",
    scroll_prompt_body:
      'Browse the catalog, use search, or reach out — we are happy to help.',
    scroll_prompt_catalog: 'View catalog',
    scroll_prompt_feedback: 'Send feedback',
    scroll_prompt_account: 'Sign in',
    nav_employee_signin: 'Employee sign in',
    cart_with_items_title: 'Basket — {{count}} product(s)',
    cart_aria_with_count: 'Shopping basket, {{count}} products',
    cart_aria_empty: 'Shopping basket, empty',
    cart_title: 'Your cart',
    cart_empty: 'Your cart is empty.',
    cart_qty_aria: 'Quantity in {{unit}}',
    cart_stock_badge: 'In stock',
    cart_stock_line_lb: '{{qty}} lb available',
    cart_stock_line_kg: '{{qty}} kg available',
    cart_shelf_life_months: 'Typically lasts about {{count}} months when stored properly.',
    cart_best_before: 'Best before: {{date}}',
    cart_rec_rail_kicker: 'Discover more',
    cart_bestsellers_title: 'Bestsellers',
    cart_bestsellers_subtitle:
      'Top-selling items across the store — not limited to one department.',
    cart_popular_bundles_title: 'Popular bundles',
    cart_popular_bundles_subtitle: 'Curated sets customers often add with their cart.',
    cart_more_picks_title: 'More to explore',
    cart_more_picks_subtitle: 'Suggestions that pair well with what you are buying.',
    cart_rec_add_short: 'Add',
    cart_suggested_products_view_all: 'Shop all',
    cart_suggested_packages_view_all: 'View bundles',
    cart_page_kicker: 'Your basket',
    cart_items_count: '{{count}} item(s)',
    cart_page_subtitle: 'Review your items below — add a few more favorites before checkout.',
    cart_empty_hint: 'Browse our catalog and add items to get started.',
    cart_fbt_title: 'Frequently bought together',
    cart_fbt_subtitle: 'Customers who bought items in your cart also added these.',
    cart_similar_title: 'Similar to your cart',
    cart_similar_subtitle: 'More from the same categories and flavor profiles.',
    cart_complete_order_title: 'Complete your order',
    cart_complete_order_subtitle: 'A few more staples to round out your delivery.',
    cart_empty_suggestions_title: 'Popular right now',
    cart_empty_suggestions_subtitle: 'Start with these customer favorites.',
    cart_trust_secure: 'Secure checkout powered by Stripe — we never store your card.',
    cart_trust_fresh: 'Fresh stock with clear best-before dates on every line.',
    continue_shopping: 'Continue shopping',
    summary: 'Summary',
    subtotal: 'Subtotal',
    order_now: 'Order Now',
    checkout: 'Checkout',
    checkout_note:
      'You will pay with a secure Stripe form. We never store full card numbers—only Stripe references and safe display fields.',
    checkout_profile_blurb:
      'We ship to the address saved on your account. Update it anytime under Account.',
    login_required: 'Please sign in to checkout.',
    checkout_customers_only: 'Only customer accounts can place store orders.',
    delivery_address: 'Delivery address',
    delivery_from_profile: 'Taken from your account profile.',
    checkout_address_toggle_expand: 'Show full delivery address',
    checkout_address_toggle_collapse: 'Hide delivery address',
    checkout_complete_profile_prompt:
      'Add your full name, phone, and full address to your account to continue.',
    checkout_go_account: 'Go to my account',
    checkout_edit_address: 'Edit address in account',
    placing_order: 'Placing order…',
    place_order: 'Go to checkout',
    checkout_step_review: 'Review',
    checkout_step_pay: 'Pay securely',
    checkout_continue_pay: 'Continue to secure payment',
    checkout_terms_policies_link: 'Terms, Privacy, Cookies and Payment Security policy',
    cookies_policy_title: 'Cookies Policy',
    payment_security_title: 'Payment Security and Compliance',
    payment_processing_powered_by: 'Payment processing is powered by',
    payment_processing_end: '.',
    legal_last_updated: 'Last updated',
    checkout_terms_first: 'I have read and agree to the',
    checkout_terms_reaccept: 'You previously agreed to the',
    checkout_terms_reaccept_suffix:
      ' on this browser. Leave this checked if you still agree. Uncheck to withdraw your consent — you cannot continue to payment until you accept again.',
    checkout_terms_required: 'Please accept the policies above before placing your order.',
    checkout_security_note:
      'Card details are encrypted in transit to Stripe. Our servers and database never receive your full card number or CVC.',
    checkout_pay_title: 'Pay with card',
    checkout_pay_subtitle:
      'Visa, Mastercard, American Express and other major cards via Stripe. You can finish later from your orders if you leave this page.',
    checkout_pay_submit: 'Pay now',
    checkout_pay_processing: 'Processing…',
    checkout_pay_error: 'Payment could not be completed.',
    checkout_pay_prepare_error: 'Unable to start payment.',
    checkout_stripe_server_off:
      'Card payments are not enabled on this server yet. Your order was created and stays pending until an administrator configures Stripe.',
    checkout_stripe_no_pk:
      'Stripe publishable key is missing in the storefront. Add REACT_APP_STRIPE_PUBLISHABLE_KEY or contact support.',
    checkout_order_ref: 'Order ID: {{id}}',
    checkout_total_due: 'Total due',
    checkout_delivery_fee: 'Delivery fees',
    checkout_discount: 'Discount',
    checkout_discount_other: 'Other discounts',
    checkout_discount_referral: 'Referral welcome',
    checkout_discount_promo_code: 'Promotion code',
    checkout_discount_checkout_line: 'Checkout line offer',
    checkout_retention_discount: 'Stay offer (account retention)',
    checkout_retention_percent_line: '{{percent}}% off merchandise subtotal (one time)',
    checkout_order_summary: 'Order summary',
    checkout_breakdown_title: 'Breakdown',
    checkout_order_reference_label: 'Order reference',
    checkout_promo_label: 'Promo code',
    checkout_promo_placeholder: 'Enter code',
    checkout_promo_apply: 'Apply',
    checkout_promo_applying: 'Applying…',
    checkout_promo_clear: 'Remove',
    checkout_promo_hint:
      'Codes may be restricted to your account or to minimum spend. Invalid codes are rejected at checkout.',
    checkout_referral_note:
      'Friend referral? Enter an invite code when you sign up (or use an invite link). If you are eligible, a welcome discount is applied automatically on this order—no code needed here. This box is for promotional discount codes only.',
    checkout_referral_welcome_subline:
      'Includes referral welcome savings on your first eligible order (−{{amount}}).',
    checkout_pick_discount_qualified:
      'You unlocked {{percent}}% off one product of your choice on this order. Choose a line below — the discount applies to that product only.',
    checkout_pick_discount_near:
      'You’re close: add about {{amount}} more to your cart subtotal to unlock {{percent}}% off one product of your choice at checkout.',
    checkout_pick_discount_choose: 'Apply {{percent}}% off to this product:',
    checkout_pick_discount_product_fallback: 'Product',
    checkout_pick_discount_subline:
      'Includes {{percent}}% “pick one” savings on the line you selected (−{{amount}}).',
    checkout_view_orders: 'View my orders',
    checkout_pay_later: 'Skip for now — view orders',
    checkout_profile_incomplete:
      'Your profile is missing delivery details. Update your account before placing an order.',
    delivery_speed_title: 'Delivery option',
    delivery_speed_standard: 'Standard route',
    delivery_speed_standard_desc:
      'Shipped with grouped deliveries in your area. Typical ETA ~{{days}} business days.',
    delivery_speed_express: 'Express',
    delivery_speed_express_desc:
      'Prioritized handling and faster route. Typical ETA ~{{days}} business day(s). Additional fee applies.',
    delivery_speed_express_unavailable: 'Express is temporarily unavailable for this destination.',
    carrier_shipping_title: 'Carrier shipping',
    carrier_shipping_subtitle:
      'Live rates from FedEx and UPS based on your cart weight and delivery address.',
    carrier_shipping_transit: 'Typical transit ~{{days}} business day(s)',
    carrier_shipping_select_required: 'Select a shipping option to continue.',
    carrier_shipping_unavailable:
      'No carrier shipping options are available for this address. Please contact support.',
    delivery_eta: 'Typical ETA',
    order_place_error: 'Unable to place order.',
    product_details: 'Product details',
    category: 'Category',
    no_description: 'No description provided.',
    go_to_cart: 'Go to cart',
    add_to_cart: 'Add to cart',
    out_of_stock: 'Out of stock',
    in_stock_lb: 'In stock: {{qty}} lb',
    product_load_error: 'Unable to load product.',
    product_image_alt: 'Product',
    home_features_title: 'Our features',
    home_features_subtitle:
      'Built-in IAM, inventory and reporting designed for grocery and fresh produce businesses.',
    home_feature_iam_title: 'Identity & access',
    home_feature_iam_body:
      'Secure IAM with roles and fine-grained permissions for admin, cashier, seller and accountant.',
    home_feature_inventory_title: 'Inventory & stock lots',
    home_feature_inventory_body:
      'FIFO-ready stock lots with purchase history, expiry dates and low-stock alerts.',
    home_feature_reporting_title: 'Reporting ready',
    home_feature_reporting_body:
      'Purchase and stock reports with fast search, filtering and pagination from day one.',
    home_cta_title: 'Ready to set up your Lewouhmart store?',
    home_cta_body:
      'Create an account, configure your catalog and invite your team in a few minutes.',
    home_cta_button: 'Sign in / Create account',
    home_journey_eyebrow: 'How shopping works',
    home_journey_title: 'From browse to doorstep',
    home_journey_subtitle:
      'A clear path: pick fresh products, pay securely with Stripe, track fulfillment, and enjoy.',
    home_journey_1: 'Browse & add to cart',
    home_journey_2: 'Pay securely online',
    home_journey_3: 'We prepare & ship',
    home_journey_4: 'Delivered to you',
    home_stats_eyebrow: 'Community snapshot',
    home_stat_customers: 'Total customers',
    home_stat_sales: 'Total sales',
    home_stat_towns: 'Towns served',
    home_rail_trending_title: 'Trending now',
    home_rail_trending_sub: 'Popular picks shoppers are adding right now.',
    home_rail_bestsellers_title: 'Best sellers',
    home_rail_bestsellers_sub: 'Steady favorites with strong demand.',
    home_rail_personal_title: 'Recommended for you',
    home_rail_personal_sub: 'Suggestions based on how you browse the store.',
    home_rail_category_sub: 'More to explore in this category.',
    home_features_eyebrow: 'Platform depth',
    products_kicker: '',
    products_title: 'Products',
    products_subtitle: '',
    view_department_details: 'View details',
    products_search_placeholder: 'Search products…',
    products_all: 'All',
    products_new_badge: 'New',
    products_in_stock_lb: 'In stock: {{qty}} lb',
    products_view_detail: 'View detail',
    products_add_to_cart: 'Add to cart',
    hero_badge: 'Lewouhmart',
    hero_fallback_headline: 'Welcome to Lewouhmart',
    hero_fallback_subheadline:
      'Fresh organic produce with real-time inventory and smart stock control.',
    hero_shop_now: 'Shop now',
    hero_slide_aria: 'Go to slide {{n}}',
    hero_value_proposition:
      'Traceable lots, live stock levels, and fulfilment you can rely on—built for serious grocery retail.',
    hero_trust_fresh: 'Curated quality',
    hero_trust_stock: 'Real-time inventory',
    hero_trust_secure: 'Secure shopping',
    hero_prev: 'Previous slide',
    hero_next: 'Next slide',
    testimonials_title: 'Customers love Lewouhmart',
    testimonials_subtitle: 'Real feedback from shoppers who rely on fast fulfillment and fresh quality.',
    testimonials_prev: 'Previous testimonials',
    testimonials_next: 'Next testimonials',
    testimonials_go_to: 'Go to testimonials page {{n}}',
    testimonial_1_body:
      'Fast delivery and excellent quality. Everything arrived in perfect condition and the checkout was easy.',
    testimonial_1_author: 'Amina K.',
    testimonial_1_meta: 'Verified customer',
    testimonial_2_body:
      'I can always find what I need. Prices are fair, and I like that recommendations help me discover new items.',
    testimonial_2_author: 'Michael S.',
    testimonial_2_meta: 'Repeat customer',
    testimonial_3_body:
      'Great customer support when I had a question about my order. Clear updates from checkout to delivery.',
    testimonial_3_author: 'Sofia R.',
    testimonial_3_meta: 'Verified customer',
    aria_facebook: 'Facebook',
    aria_twitter: 'Twitter',
    aria_linkedin: 'LinkedIn',
    aria_instagram: 'Instagram',
  },
  fr: {
    header_follow: 'Suivez-nous :',
    nav_site_label: 'Site',
    nav_about: 'À propos',
    nav_products: 'Produits',
    nav_features: 'Fonctionnalités',
    nav_contact: 'Contact',
    nav_account_label: 'Mon compte',
    nav_my_profile: 'Mon profil',
    nav_my_orders: 'Mes commandes',
    nav_referrals: 'Parrainage',
    scroll_prompt_title: 'Vous ne trouvez pas ce que vous cherchez ?',
    scroll_prompt_body:
      'Parcourez le catalogue, utilisez la recherche ou contactez-nous — nous sommes là pour vous aider.',
    scroll_prompt_catalog: 'Voir le catalogue',
    scroll_prompt_feedback: 'Envoyer un message',
    scroll_prompt_account: 'Connexion',
    nav_employee_signin: 'Connexion employé',
    cart_with_items_title: 'Panier — {{count}} produit(s)',
    cart_aria_with_count: 'Panier, {{count}} produits',
    cart_aria_empty: 'Panier vide',
    cart_title: 'Votre panier',
    cart_empty: 'Votre panier est vide.',
    cart_qty_aria: 'Quantité en {{unit}}',
    cart_stock_badge: 'En stock',
    cart_stock_line_lb: '{{qty}} lb disponibles',
    cart_stock_line_kg: '{{qty}} kg disponibles',
    cart_shelf_life_months: 'Se conserve généralement environ {{count}} mois si bien stocké.',
    cart_best_before: 'Date limite : {{date}}',
    cart_rec_rail_kicker: 'À découvrir',
    cart_bestsellers_title: 'Meilleures ventes',
    cart_bestsellers_subtitle:
      'Articles les plus vendus sur la boutique, tous rayons confondus.',
    cart_popular_bundles_title: 'Lots populaires',
    cart_popular_bundles_subtitle: 'Sélections souvent ajoutées avec le panier.',
    cart_more_picks_title: 'Autres idées',
    cart_more_picks_subtitle: 'Suggestions qui complètent votre sélection.',
    cart_rec_add_short: 'Ajouter',
    cart_suggested_products_view_all: 'Tout le catalogue',
    cart_suggested_packages_view_all: 'Voir les lots',
    continue_shopping: 'Continuer les achats',
    summary: 'Résumé',
    subtotal: 'Sous-total',
    order_now: 'Commander maintenant',
    checkout: 'Commander',
    checkout_note:
      'Paiement sécurisé via Stripe. Nous ne stockons jamais le numéro complet—seulement des références et champs d’affichage sûrs.',
    checkout_profile_blurb:
      'Nous livrons à l’adresse enregistrée sur votre compte. Modifiez-la à tout moment dans le compte.',
    login_required: 'Veuillez vous connecter pour passer commande.',
    checkout_customers_only:
      'Seuls les comptes clients peuvent passer des commandes sur la boutique.',
    delivery_address: 'Adresse de livraison',
    delivery_from_profile: 'Issue du profil de votre compte.',
    checkout_address_toggle_expand: 'Afficher l’adresse complète',
    checkout_address_toggle_collapse: 'Masquer l’adresse',
    checkout_complete_profile_prompt:
      'Ajoutez votre nom complet, téléphone et adresse complète à votre compte pour continuer.',
    checkout_go_account: 'Aller à mon compte',
    checkout_edit_address: 'Modifier l’adresse dans le compte',
    placing_order: 'Envoi de la commande…',
    place_order: 'Aller au paiement',
    checkout_step_review: 'Vérifier',
    checkout_step_pay: 'Payer en sécurité',
    checkout_continue_pay: 'Continuer vers le paiement sécurisé',
    checkout_terms_policies_link:
      'Conditions, confidentialité, cookies et sécurité des paiements',
    cookies_policy_title: 'Politique relative aux cookies',
    payment_security_title: 'Sécurité des paiements et conformité',
    payment_processing_powered_by: 'Le traitement des paiements est assuré par',
    payment_processing_end: '.',
    legal_last_updated: 'Dernière mise à jour',
    checkout_terms_first: 'J’ai lu et j’accepte les',
    checkout_terms_reaccept: 'Vous avez déjà accepté les',
    checkout_terms_reaccept_suffix:
      ' sur ce navigateur. Laissez la case cochée si vous acceptez toujours. Décochez pour retirer votre accord — vous ne pourrez pas continuer vers le paiement sans accepter à nouveau.',
    checkout_terms_required:
      'Veuillez accepter les politiques ci-dessus avant de passer commande.',
    checkout_security_note:
      'Les données carte sont chiffrées vers Stripe. Nos serveurs ne reçoivent jamais le numéro complet ni le CVC.',
    checkout_pay_title: 'Payer par carte',
    checkout_pay_subtitle:
      'Visa, Mastercard, American Express et autres cartes via Stripe. Vous pourrez terminer plus tard depuis vos commandes.',
    checkout_pay_submit: 'Payer maintenant',
    checkout_pay_processing: 'Traitement…',
    checkout_pay_error: 'Le paiement n’a pas pu aboutir.',
    checkout_pay_prepare_error: 'Impossible de démarrer le paiement.',
    checkout_stripe_server_off:
      'Le paiement par carte n’est pas activé sur ce serveur. Votre commande est créée et reste en attente.',
    checkout_stripe_no_pk:
      'Clé publique Stripe manquante (REACT_APP_STRIPE_PUBLISHABLE_KEY). Contactez le support.',
    checkout_order_ref: 'ID commande : {{id}}',
    checkout_total_due: 'Total à payer',
    checkout_delivery_fee: 'Frais de livraison',
    checkout_discount: 'Remise',
    checkout_discount_other: 'Autres remises',
    checkout_discount_referral: 'Bonus parrainage',
    checkout_discount_promo_code: 'Code promo',
    checkout_discount_checkout_line: 'Offre sur une ligne',
    checkout_retention_discount: 'Offre de fidélisation (rétention)',
    checkout_retention_percent_line: '{{percent}}% sur le sous-total marchandises (une fois)',
    checkout_order_summary: 'Récapitulatif',
    checkout_breakdown_title: 'Détail',
    checkout_order_reference_label: 'Référence commande',
    checkout_promo_label: 'Code promo',
    checkout_promo_placeholder: 'Saisir le code',
    checkout_promo_apply: 'Appliquer',
    checkout_promo_applying: 'Application…',
    checkout_promo_clear: 'Retirer',
    checkout_promo_hint:
      'Les codes peuvent être liés à votre compte ou à un montant minimum. Les codes invalides sont refusés.',
    checkout_referral_note:
      'Parrainage par un ami ? Saisissez le code d’invitation à l’inscription (ou utilisez le lien d’invitation). Si vous êtes éligible, la remise de bienvenue s’applique automatiquement sur cette commande — aucun code ici. Ce champ est réservé aux codes promotionnels.',
    checkout_referral_welcome_subline:
      'Dont la remise de bienvenue parrainage sur votre première commande éligible (−{{amount}}).',
    checkout_pick_discount_qualified:
      'Vous avez débloqué {{percent}}% sur un produit au choix pour cette commande. Choisissez une ligne ci-dessous — la remise s’applique uniquement à ce produit.',
    checkout_pick_discount_near:
      'Vous y êtes presque : ajoutez environ {{amount}} au sous-total pour débloquer {{percent}}% sur un produit au choix.',
    checkout_pick_discount_choose: 'Appliquer {{percent}}% à ce produit :',
    checkout_pick_discount_product_fallback: 'Produit',
    checkout_pick_discount_subline:
      'Dont {{percent}}% « un au choix » sur la ligne sélectionnée (−{{amount}}).',
    checkout_view_orders: 'Voir mes commandes',
    checkout_pay_later: 'Plus tard — voir mes commandes',
    checkout_profile_incomplete:
      'Votre profil ne contient pas les informations de livraison. Mettez à jour votre compte avant de commander.',
    delivery_speed_title: 'Option de livraison',
    delivery_speed_standard: 'Tournée standard',
    delivery_speed_standard_desc:
      'Regroupée avec d’autres commandes de votre zone. Délai typique ~{{days}} jours ouvrés.',
    delivery_speed_express: 'Express',
    delivery_speed_express_desc:
      'Priorité et tournée plus rapide. Délai typique ~{{days}} jour(s) ouvré(s). Supplément.',
    delivery_speed_express_unavailable: 'La livraison express est temporairement indisponible pour cette destination.',
    delivery_eta: 'Délai typique',
    order_place_error: 'Impossible de passer la commande.',
    product_details: 'Détails du produit',
    category: 'Catégorie',
    no_description: 'Aucune description fournie.',
    go_to_cart: 'Voir le panier',
    add_to_cart: 'Ajouter au panier',
    out_of_stock: 'Rupture de stock',
    in_stock_lb: 'En stock : {{qty}} lb',
    product_load_error: 'Impossible de charger le produit.',
    product_image_alt: 'Produit',
    home_features_title: 'Nos fonctionnalités',
    home_features_subtitle:
      'IAM intégré, inventaire et rapports pensés pour l’épicerie et les produits frais.',
    home_feature_iam_title: 'Identité et accès',
    home_feature_iam_body:
      'IAM sécurisé avec rôles et droits fins pour admin, caissier, vendeur et comptable.',
    home_feature_inventory_title: 'Inventaire et lots',
    home_feature_inventory_body:
      'Lots prêts pour FIFO, historique d’achats, dates de péremption et alertes de stock bas.',
    home_feature_reporting_title: 'Prêt pour les rapports',
    home_feature_reporting_body:
      'Rapports d’achats et de stock avec recherche, filtres et pagination dès le départ.',
    home_cta_title: 'Prêt à lancer votre boutique Lewouhmart ?',
    home_cta_body:
      'Créez un compte, configurez votre catalogue et invitez votre équipe en quelques minutes.',
    home_cta_button: 'Connexion / Créer un compte',
    home_journey_eyebrow: 'Le parcours d’achat',
    home_journey_title: 'Du panier à votre porte',
    home_journey_subtitle:
      'Parcours simple : choisir des produits frais, payer en ligne en toute sécurité, suivre la préparation, profiter.',
    home_journey_1: 'Parcourir et ajouter au panier',
    home_journey_2: 'Payer en ligne',
    home_journey_3: 'Préparation et expédition',
    home_journey_4: 'Livraison chez vous',
    home_stats_eyebrow: 'La communauté',
    home_stat_customers: 'Clients au total',
    home_stat_sales: 'Ventes au total',
    home_stat_towns: 'Villes desservies',
    home_rail_trending_title: 'Tendances',
    home_rail_trending_sub: 'Les articles que les clients ajoutent le plus en ce moment.',
    home_rail_bestsellers_title: 'Meilleures ventes',
    home_rail_bestsellers_sub: 'Des favoris réguliers et très demandés.',
    home_rail_personal_title: 'Pour vous',
    home_rail_personal_sub: 'Suggestions basées sur votre navigation.',
    home_rail_category_sub: 'À découvrir dans cette catégorie.',
    home_features_eyebrow: 'La plateforme',
    products_kicker: '',
    products_title: 'Produits',
    products_subtitle: '',
    view_department_details: 'Voir la fiche',
    products_search_placeholder: 'Rechercher des produits…',
    products_all: 'Tous',
    products_new_badge: 'Nouveau',
    products_in_stock_lb: 'En stock : {{qty}} lb',
    products_view_detail: 'Voir le détail',
    products_add_to_cart: 'Ajouter au panier',
    hero_badge: 'Lewouhmart',
    hero_fallback_headline: 'Bienvenue sur Lewouhmart',
    hero_fallback_subheadline:
      'Produits bio frais, inventaire en temps réel et gestion de stock intelligente.',
    hero_shop_now: 'Acheter',
    hero_slide_aria: 'Aller à la diapositive {{n}}',
    hero_value_proposition:
      'Lots traçables, stock en direct et logistique fiable—pensé pour l’épicerie professionnelle.',
    hero_trust_fresh: 'Qualité sélectionnée',
    hero_trust_stock: 'Inventaire en temps réel',
    hero_trust_secure: 'Achats sécurisés',
    hero_prev: 'Diapositive précédente',
    hero_next: 'Diapositive suivante',
    testimonials_title: 'Les clients adorent Lewouhmart',
    testimonials_subtitle:
      'Des avis réels de clients qui comptent sur une livraison rapide et une qualité fraîche.',
    testimonials_prev: 'Avis précédents',
    testimonials_next: 'Avis suivants',
    testimonials_go_to: 'Aller à la page d’avis {{n}}',
    testimonial_1_body:
      'Livraison rapide et excellente qualité. Tout est arrivé en parfait état et le paiement était simple.',
    testimonial_1_author: 'Amina K.',
    testimonial_1_meta: 'Cliente vérifiée',
    testimonial_2_body:
      'Je trouve toujours ce dont j’ai besoin. Prix corrects, et les recommandations m’aident à découvrir de nouveaux produits.',
    testimonial_2_author: 'Michael S.',
    testimonial_2_meta: 'Client fidèle',
    testimonial_3_body:
      'Très bon support client quand j’avais une question. Suivi clair de la commande jusqu’à la livraison.',
    testimonial_3_author: 'Sofia R.',
    testimonial_3_meta: 'Cliente vérifiée',
    aria_facebook: 'Facebook',
    aria_twitter: 'Twitter',
    aria_linkedin: 'LinkedIn',
    aria_instagram: 'Instagram',
  },
  es: {
    header_follow: 'Síguenos:',
    nav_site_label: 'Sitio',
    nav_about: 'Sobre nosotros',
    nav_products: 'Productos',
    nav_features: 'Funciones',
    nav_contact: 'Contacto',
    nav_account_label: 'Mi cuenta',
    nav_my_profile: 'Mi perfil',
    nav_my_orders: 'Mis pedidos',
    nav_referrals: 'Referidos',
    referral_fab_title: 'Referidos',
    referral_fab_aria: 'Abrir referidos — invita amigos y gana recompensas',
    scroll_prompt_title: '¿No encuentras lo que buscas?',
    scroll_prompt_body:
      'Explora el catálogo, usa la búsqueda o escríbenos — estaremos encantados de ayudarte.',
    scroll_prompt_catalog: 'Ver catálogo',
    scroll_prompt_feedback: 'Enviar comentarios',
    scroll_prompt_account: 'Iniciar sesión',
    nav_employee_signin: 'Acceso empleados',
    cart_with_items_title: 'Cesta — {{count}} producto(s)',
    cart_aria_with_count: 'Cesta de la compra, {{count}} productos',
    cart_aria_empty: 'Cesta de la compra vacía',
    cart_title: 'Tu cesta',
    cart_empty: 'Tu cesta está vacía.',
    cart_qty_aria: 'Cantidad en {{unit}}',
    cart_stock_badge: 'En stock',
    cart_stock_line_lb: '{{qty}} lb disponibles',
    cart_stock_line_kg: '{{qty}} kg disponibles',
    cart_shelf_life_months: 'Suele conservarse unos {{count}} meses si se guarda correctamente.',
    cart_best_before: 'Consumir antes de: {{date}}',
    cart_rec_rail_kicker: 'Descubre más',
    cart_bestsellers_title: 'Más vendidos',
    cart_bestsellers_subtitle:
      'Lo más vendido en toda la tienda, sin limitarte a un solo departamento.',
    cart_popular_bundles_title: 'Lotes populares',
    cart_popular_bundles_subtitle: 'Conjuntos que suelen añadirse junto al carrito.',
    cart_more_picks_title: 'Más sugerencias',
    cart_more_picks_subtitle: 'Ideas que combinan con lo que estás comprando.',
    cart_rec_add_short: 'Añadir',
    cart_suggested_products_view_all: 'Ver catálogo',
    cart_suggested_packages_view_all: 'Ver lotes',
    continue_shopping: 'Seguir comprando',
    summary: 'Resumen',
    subtotal: 'Subtotal',
    order_now: 'Pedir ahora',
    checkout: 'Pagar',
    checkout_note:
      'Pagarás con un formulario seguro de Stripe. No guardamos el número completo de la tarjeta.',
    checkout_profile_blurb:
      'Enviamos a la dirección guardada en tu cuenta. Actualízala cuando quieras en Cuenta.',
    login_required: 'Inicia sesión para pagar.',
    checkout_customers_only: 'Solo las cuentas de cliente pueden hacer pedidos en la tienda.',
    delivery_address: 'Dirección de envío',
    delivery_from_profile: 'Tomada del perfil de tu cuenta.',
    checkout_address_toggle_expand: 'Ver dirección completa',
    checkout_address_toggle_collapse: 'Ocultar dirección',
    checkout_complete_profile_prompt:
      'Añade tu nombre completo, teléfono y dirección completa a tu cuenta para continuar.',
    checkout_go_account: 'Ir a mi cuenta',
    checkout_edit_address: 'Editar dirección en la cuenta',
    placing_order: 'Enviando pedido…',
    place_order: 'Ir al checkout',
    checkout_step_review: 'Revisar',
    checkout_step_pay: 'Pagar con seguridad',
    checkout_continue_pay: 'Continuar al pago seguro',
    checkout_terms_policies_link:
      'Términos, privacidad, cookies y seguridad de pagos',
    cookies_policy_title: 'Política de cookies',
    payment_security_title: 'Seguridad de pagos y cumplimiento',
    payment_processing_powered_by: 'El procesamiento de pagos está impulsado por',
    payment_processing_end: '.',
    legal_last_updated: 'Última actualización',
    checkout_terms_first: 'He leído y acepto los',
    checkout_terms_reaccept: 'Ya aceptaste los',
    checkout_terms_reaccept_suffix:
      ' en este navegador. Deja marcada la casilla si sigues de acuerdo. Desmárcala para retirar tu consentimiento: no podrás continuar al pago hasta volver a aceptar.',
    checkout_terms_required:
      'Acepta las políticas anteriores antes de realizar el pedido.',
    checkout_security_note:
      'Los datos de la tarjeta van cifrados a Stripe. Nuestros servidores no reciben el PAN completo ni el CVC.',
    checkout_pay_title: 'Pagar con tarjeta',
    checkout_pay_subtitle:
      'Visa, Mastercard, American Express y otras tarjetas vía Stripe. Puedes terminar más tarde desde tus pedidos.',
    checkout_pay_submit: 'Pagar ahora',
    checkout_pay_processing: 'Procesando…',
    checkout_pay_error: 'No se pudo completar el pago.',
    checkout_pay_prepare_error: 'No se pudo iniciar el pago.',
    checkout_stripe_server_off:
      'El pago con tarjeta no está activado en este servidor. Tu pedido queda pendiente.',
    checkout_stripe_no_pk:
      'Falta la clave publicable de Stripe (REACT_APP_STRIPE_PUBLISHABLE_KEY).',
    checkout_order_ref: 'ID de pedido: {{id}}',
    checkout_total_due: 'Total a pagar',
    checkout_delivery_fee: 'Gastos de envío',
    checkout_discount: 'Descuento',
    checkout_discount_other: 'Otros descuentos',
    checkout_discount_referral: 'Bienvenida por referido',
    checkout_discount_promo_code: 'Código promocional',
    checkout_discount_checkout_line: 'Descuento en una línea',
    checkout_retention_discount: 'Oferta de permanencia (retención)',
    checkout_retention_percent_line: '{{percent}}% sobre el subtotal de productos (una vez)',
    checkout_order_summary: 'Resumen del pedido',
    checkout_breakdown_title: 'Desglose',
    checkout_order_reference_label: 'Referencia del pedido',
    checkout_promo_label: 'Código promocional',
    checkout_promo_placeholder: 'Introducir código',
    checkout_promo_apply: 'Aplicar',
    checkout_promo_applying: 'Aplicando…',
    checkout_promo_clear: 'Quitar',
    checkout_promo_hint:
      'Los códigos pueden estar vinculados a tu cuenta o a un gasto mínimo. Los códigos no válidos se rechazan.',
    checkout_referral_note:
      '¿Te invitó un amigo? Indica el código al registrarte (o usa el enlace de invitación). Si eres elegible, el descuento de bienvenida se aplica solo en este pedido—no hace falta código aquí. Esta casilla es solo para códigos promocionales.',
    checkout_referral_welcome_subline:
      'Incluye el ahorro de bienvenida por referidos en tu primer pedido elegible (−{{amount}}).',
    checkout_pick_discount_qualified:
      'Has desbloqueado un {{percent}}% en un producto a elegir en este pedido. Elige una línea abajo; el descuento solo aplica a ese producto.',
    checkout_pick_discount_near:
      'Casi: añade unos {{amount}} más al subtotal para desbloquear un {{percent}}% en un producto a elegir.',
    checkout_pick_discount_choose: 'Aplicar {{percent}}% a este producto:',
    checkout_pick_discount_product_fallback: 'Producto',
    checkout_pick_discount_subline:
      'Incl. {{percent}}% «elige uno» en la línea seleccionada (−{{amount}}).',
    checkout_view_orders: 'Ver mis pedidos',
    checkout_pay_later: 'Más tarde — ver pedidos',
    checkout_profile_incomplete:
      'A tu perfil le faltan datos de envío. Actualiza tu cuenta antes de pedir.',
    delivery_speed_title: 'Opción de entrega',
    delivery_speed_standard: 'Ruta estándar',
    delivery_speed_standard_desc:
      'Agrupada con otros pedidos de tu zona. Plazo típico ~{{days}} días laborables.',
    delivery_speed_express: 'Exprés',
    delivery_speed_express_desc:
      'Prioridad y ruta más rápida. Plazo típico ~{{days}} día(s) laborable(s). Suplemento.',
    delivery_speed_express_unavailable: 'La entrega exprés no está disponible temporalmente para este destino.',
    delivery_eta: 'Plazo típico',
    order_place_error: 'No se pudo realizar el pedido.',
    product_details: 'Detalles del producto',
    category: 'Categoría',
    no_description: 'Sin descripción.',
    go_to_cart: 'Ir al carrito',
    add_to_cart: 'Añadir al carrito',
    out_of_stock: 'Agotado',
    in_stock_lb: 'En stock: {{qty}} lb',
    product_load_error: 'No se pudo cargar el producto.',
    product_image_alt: 'Producto',
    home_features_title: 'Nuestras funciones',
    home_features_subtitle:
      'IAM integrado, inventario e informes pensados para comercio y producto fresco.',
    home_feature_iam_title: 'Identidad y acceso',
    home_feature_iam_body:
      'IAM seguro con roles y permisos detallados para admin, cajero, vendedor y contable.',
    home_feature_inventory_title: 'Inventario y lotes',
    home_feature_inventory_body:
      'Lotes listos para FIFO, historial de compras, caducidades y alertas de stock bajo.',
    home_feature_reporting_title: 'Listo para informes',
    home_feature_reporting_body:
      'Informes de compras y stock con búsqueda, filtros y paginación desde el primer día.',
    home_cta_title: '¿Listo para montar tu tienda Lewouhmart?',
    home_cta_body:
      'Crea una cuenta, configura tu catálogo e invita a tu equipo en minutos.',
    home_cta_button: 'Iniciar sesión / Crear cuenta',
    home_journey_eyebrow: 'Cómo comprar',
    home_journey_title: 'Del carrito a tu puerta',
    home_journey_subtitle:
      'Elige productos frescos, paga con seguridad, sigue el envío y disfruta.',
    home_journey_1: 'Explorar y añadir al carrito',
    home_journey_2: 'Pagar en línea',
    home_journey_3: 'Preparamos y enviamos',
    home_journey_4: 'Te lo llevamos',
    home_stats_eyebrow: 'Nuestra comunidad',
    home_stat_customers: 'Clientes en total',
    home_stat_sales: 'Ventas en total',
    home_stat_towns: 'Poblaciones',
    home_rail_trending_title: 'Tendencias',
    home_rail_trending_sub: 'Lo que más están añadiendo ahora.',
    home_rail_bestsellers_title: 'Más vendidos',
    home_rail_bestsellers_sub: 'Favoritos con mucha demanda.',
    home_rail_personal_title: 'Recomendado para ti',
    home_rail_personal_sub: 'Basado en cómo navegas la tienda.',
    home_rail_category_sub: 'Más en esta categoría.',
    home_features_eyebrow: 'La plataforma',
    products_kicker: '',
    products_title: 'Productos',
    products_subtitle: '',
    view_department_details: 'Ver detalles',
    products_search_placeholder: 'Buscar productos…',
    products_all: 'Todos',
    products_new_badge: 'Nuevo',
    products_in_stock_lb: 'En stock: {{qty}} lb',
    products_view_detail: 'Ver detalle',
    products_add_to_cart: 'Añadir al carrito',
    hero_badge: 'Lewouhmart',
    hero_fallback_headline: 'Bienvenido a Lewouhmart',
    hero_fallback_subheadline:
      'Producto ecológico fresco con inventario en tiempo real y control de stock inteligente.',
    hero_shop_now: 'Comprar ahora',
    hero_slide_aria: 'Ir a la diapositiva {{n}}',
    hero_value_proposition:
      'Lotes trazables, stock en vivo y entregas fiables—pensado para retail de alimentación.',
    hero_trust_fresh: 'Calidad seleccionada',
    hero_trust_stock: 'Inventario en vivo',
    hero_trust_secure: 'Compra segura',
    hero_prev: 'Diapositiva anterior',
    hero_next: 'Diapositiva siguiente',
    testimonials_title: 'A los clientes les encanta Lewouhmart',
    testimonials_subtitle:
      'Opiniones reales de compradores que confían en entregas rápidas y calidad fresca.',
    testimonials_prev: 'Testimonios anteriores',
    testimonials_next: 'Siguientes testimonios',
    testimonials_go_to: 'Ir a la página de testimonios {{n}}',
    testimonial_1_body:
      'Entrega rápida y excelente calidad. Todo llegó en perfecto estado y el pago fue muy fácil.',
    testimonial_1_author: 'Amina K.',
    testimonial_1_meta: 'Cliente verificado',
    testimonial_2_body:
      'Siempre encuentro lo que necesito. Precios justos y las recomendaciones me ayudan a descubrir nuevos productos.',
    testimonial_2_author: 'Michael S.',
    testimonial_2_meta: 'Cliente recurrente',
    testimonial_3_body:
      'Excelente soporte cuando tuve una pregunta. Actualizaciones claras desde el pago hasta la entrega.',
    testimonial_3_author: 'Sofia R.',
    testimonial_3_meta: 'Cliente verificado',
    aria_facebook: 'Facebook',
    aria_twitter: 'Twitter',
    aria_linkedin: 'LinkedIn',
    aria_instagram: 'Instagram',
  },
  de: {
    header_follow: 'Folgen Sie uns:',
    nav_site_label: 'Website',
    nav_about: 'Über uns',
    nav_products: 'Produkte',
    nav_features: 'Funktionen',
    nav_contact: 'Kontakt',
    nav_account_label: 'Mein Konto',
    nav_my_profile: 'Mein Profil',
    nav_my_orders: 'Meine Bestellungen',
    nav_referrals: 'Empfehlungen',
    referral_fab_title: 'Empfehlungen',
    referral_fab_aria: 'Empfehlungen öffnen — Freunde einladen und Prämien sichern',
    scroll_prompt_title: 'Finden Sie nicht, was Sie suchen?',
    scroll_prompt_body:
      'Stöbern Sie im Katalog, nutzen Sie die Suche oder kontaktieren Sie uns — wir helfen gerne.',
    scroll_prompt_catalog: 'Zum Katalog',
    scroll_prompt_feedback: 'Feedback senden',
    scroll_prompt_account: 'Anmelden',
    nav_employee_signin: 'Mitarbeiter-Anmeldung',
    cart_with_items_title: 'Warenkorb — {{count}} Produkt(e)',
    cart_aria_with_count: 'Warenkorb, {{count}} Produkte',
    cart_aria_empty: 'Warenkorb leer',
    cart_title: 'Ihr Warenkorb',
    cart_empty: 'Ihr Warenkorb ist leer.',
    cart_qty_aria: 'Menge in {{unit}}',
    cart_stock_badge: 'Auf Lager',
    cart_stock_line_lb: '{{qty}} lb verfügbar',
    cart_stock_line_kg: '{{qty}} kg verfügbar',
    cart_shelf_life_months: 'Hält in der Regel etwa {{count}} Monate bei sachgemäßer Lagerung.',
    cart_best_before: 'Mindestens haltbar bis: {{date}}',
    cart_rec_rail_kicker: 'Mehr entdecken',
    cart_bestsellers_title: 'Bestseller',
    cart_bestsellers_subtitle:
      'Die meistverkauften Artikel im gesamten Shop — branchenübergreifend.',
    cart_popular_bundles_title: 'Beliebte Bundles',
    cart_popular_bundles_subtitle: 'Zusammenstellungen, die oft zum Warenkorb passen.',
    cart_more_picks_title: 'Mehr Inspiration',
    cart_more_picks_subtitle: 'Vorschläge, die gut zu Ihrem Warenkorb passen.',
    cart_rec_add_short: 'Hinzufügen',
    cart_suggested_products_view_all: 'Alle Produkte',
    cart_suggested_packages_view_all: 'Bundles ansehen',
    continue_shopping: 'Weiter einkaufen',
    summary: 'Übersicht',
    subtotal: 'Zwischensumme',
    order_now: 'Jetzt bestellen',
    checkout: 'Zur Kasse',
    checkout_note:
      'Sie zahlen über ein sicheres Stripe-Formular. Wir speichern niemals die vollständige Kartennummer.',
    checkout_profile_blurb:
      'Wir liefern an die im Konto gespeicherte Adresse. Sie können sie jederzeit unter Konto ändern.',
    login_required: 'Bitte melden Sie sich an, um zu bestellen.',
    checkout_customers_only:
      'Nur Kundenkonten können Shop-Bestellungen aufgeben.',
    delivery_address: 'Lieferadresse',
    delivery_from_profile: 'Aus Ihrem Kontoprofil übernommen.',
    checkout_address_toggle_expand: 'Vollständige Adresse anzeigen',
    checkout_address_toggle_collapse: 'Adresse ausblenden',
    checkout_complete_profile_prompt:
      'Ergänzen Sie vollständigen Namen, Telefon und Adresse im Konto, um fortzufahren.',
    checkout_go_account: 'Zu meinem Konto',
    checkout_edit_address: 'Adresse im Konto bearbeiten',
    placing_order: 'Bestellung wird gesendet…',
    place_order: 'Zur Kasse',
    checkout_step_review: 'Prüfen',
    checkout_step_pay: 'Sicher bezahlen',
    checkout_continue_pay: 'Weiter zur sicheren Zahlung',
    checkout_terms_policies_link:
      'AGB, Datenschutz, Cookies und Zahlungssicherheit',
    cookies_policy_title: 'Cookie-Richtlinie',
    payment_security_title: 'Zahlungssicherheit und Compliance',
    payment_processing_powered_by: 'Die Zahlungsabwicklung erfolgt durch',
    payment_processing_end: '.',
    legal_last_updated: 'Zuletzt aktualisiert',
    checkout_terms_first: 'Ich habe gelesen und stimme zu:',
    checkout_terms_reaccept: 'Sie haben zuvor zugestimmt:',
    checkout_terms_reaccept_suffix:
      ' in diesem Browser. Lassen Sie das Kontrollkästchen aktiviert, wenn Sie weiter zustimmen. Deaktivieren Sie es, um Ihre Zustimmung zurückzunehmen — ohne erneute Zustimmung ist keine Zahlung möglich.',
    checkout_terms_required:
      'Bitte akzeptieren Sie die obigen Richtlinien, bevor Sie bestellen.',
    checkout_security_note:
      'Kartendaten werden verschlüsselt an Stripe übermittelt. Unsere Server erhalten nie die vollständige Nummer oder CVC.',
    checkout_pay_title: 'Mit Karte zahlen',
    checkout_pay_subtitle:
      'Visa, Mastercard, American Express u. a. über Stripe. Sie können später unter „Bestellungen“ abschließen.',
    checkout_pay_submit: 'Jetzt zahlen',
    checkout_pay_processing: 'Wird verarbeitet…',
    checkout_pay_error: 'Zahlung fehlgeschlagen.',
    checkout_pay_prepare_error: 'Zahlung konnte nicht gestartet werden.',
    checkout_stripe_server_off:
      'Kartenzahlung auf diesem Server nicht aktiviert. Ihre Bestellung bleibt ausstehend.',
    checkout_stripe_no_pk:
      'Öffentlicher Stripe-Schlüssel fehlt (REACT_APP_STRIPE_PUBLISHABLE_KEY).',
    checkout_order_ref: 'Bestell-ID: {{id}}',
    checkout_total_due: 'Zu zahlender Betrag',
    checkout_delivery_fee: 'Liefergebühren',
    checkout_discount: 'Rabatt',
    checkout_discount_other: 'Weitere Rabatte',
    checkout_discount_referral: 'Empfehlungs-Bonus',
    checkout_discount_promo_code: 'Aktionscode',
    checkout_discount_checkout_line: 'Rabatt auf eine Position',
    checkout_retention_discount: 'Bleib-Angebot (Kontobindung)',
    checkout_retention_percent_line: '{{percent}}% auf Warenzwischensumme (einmalig)',
    checkout_order_summary: 'Bestellübersicht',
    checkout_breakdown_title: 'Aufschlüsselung',
    checkout_order_reference_label: 'Bestellreferenz',
    checkout_promo_label: 'Aktionscode',
    checkout_promo_placeholder: 'Code eingeben',
    checkout_promo_apply: 'Anwenden',
    checkout_promo_applying: 'Wird angewendet…',
    checkout_promo_clear: 'Entfernen',
    checkout_promo_hint:
      'Codes können an Ihr Konto oder einen Mindestbetrag gebunden sein. Ungültige Codes werden abgelehnt.',
    checkout_referral_note:
      'Empfehlung von Freunden? Geben Sie den Einladungscode bei der Registrierung ein (oder nutzen Sie den Einladungslink). Wenn Sie berechtigt sind, wird der Willkommensrabatt automatisch auf diese Bestellung angewendet — hier kein Code nötig. Dieses Feld ist nur für Aktionscodes.',
    checkout_referral_welcome_subline:
      'Davon Empfehlungs-Willkommensrabatt auf Ihre erste berechtigte Bestellung (−{{amount}}).',
    checkout_pick_discount_qualified:
      'Sie haben {{percent}}% auf ein Produkt Ihrer Wahl für diese Bestellung freigeschaltet. Wählen Sie unten eine Position — der Rabatt gilt nur dafür.',
    checkout_pick_discount_near:
      'Fast geschafft: Erhöhen Sie den Warenwert um etwa {{amount}}, um {{percent}}% auf ein Produkt Ihrer Wahl zu erhalten.',
    checkout_pick_discount_choose: '{{percent}}% auf dieses Produkt anwenden:',
    checkout_pick_discount_product_fallback: 'Produkt',
    checkout_pick_discount_subline:
      'Davon {{percent}}% «Ein Produkt wählen» auf die gewählte Position (−{{amount}}).',
    checkout_view_orders: 'Meine Bestellungen',
    checkout_pay_later: 'Später — Bestellungen ansehen',
    checkout_profile_incomplete:
      'Ihrem Profil fehlen Lieferdaten. Aktualisieren Sie Ihr Konto vor der Bestellung.',
    delivery_speed_title: 'Lieferoption',
    delivery_speed_standard: 'Standard-Tour',
    delivery_speed_standard_desc:
      'Zusammen mit anderen Sendungen in Ihrer Region. Typisch ~{{days}} Werktage.',
    delivery_speed_express: 'Express',
    delivery_speed_express_desc:
      'Priorität und schnellere Tour. Typisch ~{{days}} Werktag(e). Aufpreis.',
    delivery_speed_express_unavailable: 'Express ist für dieses Ziel vorübergehend nicht verfügbar.',
    delivery_eta: 'Vorauss. Lieferzeit',
    order_place_error: 'Bestellung konnte nicht aufgegeben werden.',
    product_details: 'Produktdetails',
    category: 'Kategorie',
    no_description: 'Keine Beschreibung vorhanden.',
    go_to_cart: 'Zum Warenkorb',
    add_to_cart: 'In den Warenkorb',
    out_of_stock: 'Nicht vorrätig',
    in_stock_lb: 'Auf Lager: {{qty}} lb',
    product_load_error: 'Produkt konnte nicht geladen werden.',
    product_image_alt: 'Produkt',
    home_features_title: 'Unsere Funktionen',
    home_features_subtitle:
      'Integriertes IAM, Lager und Berichte für Lebensmittel und Frischeware.',
    home_feature_iam_title: 'Identität & Zugriff',
    home_feature_iam_body:
      'Sicheres IAM mit Rollen und feingranularen Rechten für Admin, Kasse, Verkauf und Buchhaltung.',
    home_feature_inventory_title: 'Lager & Chargen',
    home_feature_inventory_body:
      'FIFO-fähige Chargen mit Einkaufshistorie, MHD und Niedrigbestandswarnungen.',
    home_feature_reporting_title: 'Berichte ab Tag eins',
    home_feature_reporting_body:
      'Einkaufs- und Lagerberichte mit Suche, Filtern und Paginierung.',
    home_cta_title: 'Bereit für Ihren Lewouhmart-Shop?',
    home_cta_body:
      'Konto anlegen, Katalog einrichten und Team in wenigen Minuten einladen.',
    home_cta_button: 'Anmelden / Konto erstellen',
    home_journey_eyebrow: 'So funktioniert’s',
    home_journey_title: 'Vom Warenkorb bis zur Haustür',
    home_journey_subtitle:
      'Produkte wählen, sicher mit Stripe bezahlen, Lieferung verfolgen und genießen.',
    home_journey_1: 'Stöbern & in den Warenkorb',
    home_journey_2: 'Sicher online bezahlen',
    home_journey_3: 'Wir packen & versenden',
    home_journey_4: 'Lieferung zu Ihnen',
    home_stats_eyebrow: 'Unsere Community',
    home_stat_customers: 'Kunden gesamt',
    home_stat_sales: 'Verkäufe gesamt',
    home_stat_towns: 'Belieferte Orte',
    home_rail_trending_title: 'Gerade angesagt',
    home_rail_trending_sub: 'Was Kunden gerade am häufigsten in den Warenkorb legen.',
    home_rail_bestsellers_title: 'Bestseller',
    home_rail_bestsellers_sub: 'Stabile Favoriten mit hoher Nachfrage.',
    home_rail_personal_title: 'Für Sie empfohlen',
    home_rail_personal_sub: 'Basierend auf Ihrem Surfverhalten im Shop.',
    home_rail_category_sub: 'Mehr aus dieser Kategorie.',
    home_features_eyebrow: 'Die Plattform',
    products_kicker: '',
    products_title: 'Produkte',
    products_subtitle: '',
    view_department_details: 'Details ansehen',
    products_search_placeholder: 'Produkte suchen…',
    products_all: 'Alle',
    products_new_badge: 'Neu',
    products_in_stock_lb: 'Auf Lager: {{qty}} lb',
    products_view_detail: 'Details anzeigen',
    products_add_to_cart: 'In den Warenkorb',
    hero_badge: 'Lewouhmart',
    hero_fallback_headline: 'Willkommen bei Lewouhmart',
    hero_fallback_subheadline:
      'Frische Bio-Produkte mit Echtzeit-Bestand und smarter Lagerverwaltung.',
    hero_shop_now: 'Jetzt shoppen',
    hero_slide_aria: 'Zu Folie {{n}} springen',
    hero_value_proposition:
      'Nachverfolgbare Chargen, Live-Bestand und zuverlässige Abwicklung—für professionellen Lebensmittelhandel.',
    hero_trust_fresh: 'Ausgewählte Qualität',
    hero_trust_stock: 'Echtzeit-Bestand',
    hero_trust_secure: 'Sicheres Einkaufen',
    hero_prev: 'Vorherige Folie',
    hero_next: 'Nächste Folie',
    aria_facebook: 'Facebook',
    aria_twitter: 'Twitter',
    aria_linkedin: 'LinkedIn',
    aria_instagram: 'Instagram',
  },
} as const;
